import React from 'react';
import { useTranslation } from 'react-i18next';

import Logo from '@/components/common/logo';
import ForgotPasswordForm from './components/forgotPasswordForm';

const ForgotPasswordPage: React.FC = () => {
  const [t] = useTranslation('');
  return (
    <div className="flex-full-center h-screen bg-primary-900">
      <div className="w-[440px]">
        <div className="flex-full-center">
          <Logo />
        </div>
        <h2 className="title text-white text-[30px] leading-[38px] font-bold flex-full-center mt-[24px] mb-[12px]">
          {t('forgot_password.title')}
        </h2>
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
